import { api, intakeApi, type Api } from './client';

/**
 * Where the ticket form and the assistant draft send their requests. Members use the project-scoped API; the
 * external-intake popup uses the same paths under its own API without the project prefix (JIRA-19).
 */
export interface TicketCreation {
  client: Api;
  /** Prefix of ticket and assistant paths: `/projects/APP` for members, empty in the intake popup. */
  base: string;
  /** Cache scope for this surface's queries. */
  scope: string;
  /** Who is writing, shown on their messages to the assistant. */
  requesterName: string;
  /** In-app link to a ticket; absent where the person cannot open tickets (the intake popup). */
  ticketHref?: (number: number) => string;
}

export const memberCreation = (projectKey: string, requesterName: string): TicketCreation => ({
  client: api,
  base: `/projects/${projectKey}`,
  scope: projectKey,
  requesterName,
  ticketHref: (n) => `/projects/${projectKey}/tickets/${n}`,
});

export const intakeCreation = (requesterName: string): TicketCreation => ({
  client: intakeApi,
  base: '',
  scope: 'intake',
  requesterName,
});
